// NOVO ARQUIVO
import React, { useState } from 'react';
import useData from '../../hooks/useData';
import GlassButton from '../ui/Button';
import { AddIcon, DeleteIcon, EditIcon, SaveIcon } from '../ui/Icons';

const TermsManagerModal = ({ onClose }) => {
    const { termsTemplates, handleSaveTermsTemplate, handleDeleteTermsTemplate } = useData();
    const [newTemplate, setNewTemplate] = useState({ title: '', content: '' });
    const [editingId, setEditingId] = useState(null);

    const handleSave = async () => {
        if (!newTemplate.title || !newTemplate.content) return;
        
        if (editingId) {
            await handleSaveTermsTemplate({ id: editingId, ...newTemplate });
            setEditingId(null);
        } else {
            await handleSaveTermsTemplate(newTemplate);
        }
        setNewTemplate({ title: '', content: '' });
    };

    const handleEdit = (template) => {
        setEditingId(template.id);
        setNewTemplate({ title: template.title, content: template.content });
    };

    return (
        <div className="p-6 text-white max-w-3xl w-full">
            <h2 className="text-2xl font-bold mb-4">Banco de Termos e Condições</h2>

            <div className="space-y-2 max-h-64 overflow-y-auto pr-2 mb-4">
                {termsTemplates.map(template => (
                    <div key={template.id} className="flex justify-between items-center bg-white/5 p-3 rounded-lg">
                        <p className="font-semibold">{template.title}</p>
                        <div className="flex items-center gap-2">
                            <button onClick={() => handleEdit(template)} className="text-blue-300 hover:underline text-sm p-1"><EditIcon size={16}/></button>
                            <button onClick={() => handleDeleteTermsTemplate(template.id)} className="text-red-400 hover:underline text-sm p-1"><DeleteIcon size={16}/></button>
                        </div>
                    </div>
                ))}
            </div>

            <div className="bg-white/10 p-4 rounded-lg flex flex-col gap-2">
                <input type="text" placeholder="Título do Template (ex: Pagamento 50/50)" value={newTemplate.title} onChange={(e) => setNewTemplate(p => ({ ...p, title: e.target.value }))} className="w-full p-2 bg-black/20 rounded"/>
                <textarea rows="5" placeholder="Conteúdo dos termos..." value={newTemplate.content} onChange={(e) => setNewTemplate(p => ({ ...p, content: e.target.value }))} className="w-full p-2 bg-black/20 rounded"/>
                <GlassButton onClick={handleSave} className="!bg-indigo-500 self-end">
                    {editingId ? <SaveIcon /> : <AddIcon />}
                    <span className="ml-2">{editingId ? 'Salvar Alterações' : 'Adicionar Template'}</span>
                </GlassButton>
            </div>
            
            <div className="mt-6 text-right">
                <GlassButton onClick={onClose}>Fechar</GlassButton>
            </div>
        </div>
    );
};

export default TermsManagerModal;